import { render, staticRenderFns } from "./EnterDetails.vue?vue&type=template&id=1cc21048&scoped=true&"
import script from "./EnterDetails.vue?vue&type=script&lang=js&"
export * from "./EnterDetails.vue?vue&type=script&lang=js&"
import style0 from "./EnterDetails.vue?vue&type=style&index=0&id=1cc21048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc21048",
  null
  
)

export default component.exports